import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _objectSpread from '@babel/runtime/helpers/esm/objectSpread';
import React from 'react';

function getElementType(element) {
  if (!React.isValidElement(element)) {
    return null;
  }

  return element.type;
}
/**
 * clone chilrens with passed props to ensure some nested components props works
 * @param children
 * @param props
 * @returns
 */


var childrenWithContext = function childrenWithContext(children) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return React.createElement(React.Fragment, null, React.Children.map(children, function (child) {
    if (!React.isValidElement(child)) {
      return child;
    }

    return React.cloneElement(child, _objectSpread({}, props, {
      children: child.props.children
    }));
  }));
};

var If = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(If, _React$PureComponent);

  function If() {
    _classCallCheck(this, If);

    return _possibleConstructorReturn(this, _getPrototypeOf(If).apply(this, arguments));
  }

  _createClass(If, [{
    key: "render",
    value: function render() {
      var children = React.Children.toArray(this.props.children);
      var elements;

      if (this.props.condition) {
        // render without content in <ElIf> and <Else>
        elements = children.filter(function (child) {
          var type = getElementType(child);

          if (!type) {
            return child;
          }

          return type !== ElIf && type !== Else;
        });
      } else {
        // find <ElIf> with `condition==true`;
        var validElif = children.find(function (child) {
          if (!React.isValidElement(child)) {
            return false;
          }

          return child.type === ElIf && child.props.condition;
        }); // if not exist valid <ElIf>, find <Else>

        elements = validElif || children.find(function (child) {
          if (!React.isValidElement(child)) {
            return false;
          }

          return child.type === Else;
        });
      }

      return elements ? childrenWithContext(elements, _objectSpread({
        withinIf: true
      }, this.props)) : null;
    }
  }]);

  return If;
}(React.PureComponent);

var ElIf = /*#__PURE__*/function (_React$PureComponent2) {
  _inherits(ElIf, _React$PureComponent2);

  function ElIf() {
    _classCallCheck(this, ElIf);

    return _possibleConstructorReturn(this, _getPrototypeOf(ElIf).apply(this, arguments));
  }

  _createClass(ElIf, [{
    key: "render",
    value: function render() {
      if (!this.props.withinIf) {
        // <ElIf> should be a nested child of <If> component
        return null;
      }

      return childrenWithContext(this.props.children, this.props);
    }
  }]);

  return ElIf;
}(React.PureComponent);

var Else = /*#__PURE__*/function (_React$PureComponent3) {
  _inherits(Else, _React$PureComponent3);

  function Else() {
    _classCallCheck(this, Else);

    return _possibleConstructorReturn(this, _getPrototypeOf(Else).apply(this, arguments));
  }

  _createClass(Else, [{
    key: "render",
    value: function render() {
      if (!this.props.withinIf) {
        // <Else> should be a nested child of <If> component
        return null;
      }

      return childrenWithContext(this.props.children, this.props);
    }
  }]);

  return Else;
}(React.PureComponent);

export { ElIf, Else, If };